module.exports = __webpack_public_path__ + "img/warranty.f7402533.png";